import 'slick-slider';
import '@fancyapps/fancybox';

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    $('.photography__slider').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 2.2,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $('.photography__controls .prev-slide'),
      nextArrow: $('.photography__controls .next-slide'),

      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1.8,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.3,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js